






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Place } from '@/Dto';
import PanelPlacesList from './PanelPlacesList.vue';
import PanelPlaceDetail from './PanelPlaceDetail.vue';
import MiniPanelPlaceDetail from './MiniPanelPlaceDetail.vue';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import "leaflet/dist/leaflet.css";
import * as L from 'leaflet';
import 'leaflet.awesome-markers';
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.css';
import { Util } from '@/Util';

@Component({
  components: {
    'panel-places-list': PanelPlacesList,
    'panel-place-detail': PanelPlaceDetail,
    'mini-panel-place-detail': MiniPanelPlaceDetail,
    'l-map': LMap,
    'l-tile-layer': LTileLayer,
    'l-marker': LMarker
  }
})
export default class PlacesMap extends Vue {

  @Watch('places')
  onPlacesChange(val: Array<Place>, old: Array<Place>) {
    this.fitBounds();
  }

  private standardIcon = L.AwesomeMarkers.icon({
    prefix: 'fa',
    icon: 'cutlery',
    markerColor: 'green'
  });

  private selectedIcon = L.AwesomeMarkers.icon({
    prefix: 'fa',
    icon: 'cutlery',
    markerColor: 'red'
  });

  get zoom() {
    return 13;
  }

  get center() {
    return L.latLng(47.413220, -1.219482);
  }

  get url() {
    return 'https://{s}.tile.osm.org/{z}/{x}/{y}.png';
  }

  get attribution() {
    return '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
  }

  get places() {
    return this.$store.getters.filteredPlaces;
  }

  selectPlace(index:Number) {
    this.$store.commit("selectPlace", index);
  }

  get selectedPlace() {
    return this.$store.getters.selectedPlace;
  }

  get selectedPlaceIndex() {
    return this.$store.getters.selectedPlaceIndex;
  }

  icon(place:Place) {
    if (place === this.selectedPlace) {
      return this.selectedIcon;
    }
    return this.standardIcon;
  }

  latlong(place:Place) {
    const coord = place.latlng.split(',');
    return L.latLng(+coord[0], +coord[1]);
  }

  previous() {
    const previous = this.$store.getters.selectedPlaceIndex - 1;
    this.$store.commit("selectPlace", previous < 0 ? this.places.length -1 : previous);
  }

  next() {
    const next = this.$store.getters.selectedPlaceIndex + 1;
    this.$store.commit("selectPlace", next === this.places.length ? 0 : next);
  }

  mounted() {
    this.$ga.page(Util.getTrackingUrl(this.$store.getters.view.toLowerCase(), this.$store.getters.filter.search));
    this.fitBounds();
  }

  fitBounds() {
    if (this.places && this.places.length > 0) {
      const latlongs = this.places.map((place:Place) => {
        const coord = place.latlng.split(',');
        return L.latLng(+coord[0], +coord[1]);
      });
      const bounds:L.LatLngBounds = L.latLngBounds(latlongs);
      (this.$refs.map as LMap).fitBounds(bounds);    }
  }
}
